import React from 'react'
import styled from 'styled-components'
import { position, space } from 'styled-system'
import Box from '@components/Box'
import cornerTopLeft from '@components/ArtDecoContainer/assets/top-left.svg'
import cornerTopRight from '@components/ArtDecoContainer/assets/top-right.svg'
import cornerBottomLeft from '@components/ArtDecoContainer/assets/bottom-left.svg'
import cornerBottomRight from '@components/ArtDecoContainer/assets/bottom-right.svg'

const StyledImg = styled.img`
  ${position}
  ${space}
`

const ArtDecoContainer = ({ children, ...rest }) => {
  return (
    <Box
      position="relative"
      bg="rgba(108, 98, 84, 0.8)"
      borderStyle="solid"
      borderWidth="2px"
      borderColor="border"
      py="42px"
      m="2px"
      {...rest}
    >
      {children}
      <StyledImg
        position="absolute"
        top="-4px"
        left="-4px"
        src={cornerTopLeft}
        alt=""
      />
      <StyledImg
        position="absolute"
        top="-4px"
        right="-4px"
        src={cornerTopRight}
        alt=""
      />
      <StyledImg
        position="absolute"
        bottom="-4px"
        left="-4px"
        src={cornerBottomLeft}
        alt=""
      />
      <StyledImg
        position="absolute"
        bottom="-4px"
        right="-4px"
        src={cornerBottomRight}
        alt=""
      />
    </Box>
  )
}

export default ArtDecoContainer
